import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { PersonalityTestQuestionsDto } from "../generated/generatedTypes";

const getAllPersonalityQuestions = async (): Promise<PersonalityTestQuestionsDto> => {
  const response = await apiFetch("api/questions/personality-test");
  if (!response.ok) throw new Error("GET api/questions/personality-test failed");
  return response.json();
};

export function useGetAllPersonalityQuestions() {
  return useQuery({
    queryKey: ["allPersonalityQuestions"],
    queryFn: getAllPersonalityQuestions,
  });
}

